import React, { useEffect, useState, useRef } from 'react'
import {
  Link,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min'
import {
  Layout,
  Button,
  Input,
  Select,
  Typography,
  Divider,
  Spin,
  Row,
  message,
  Modal,
  Breadcrumb,
  Tabs,
} from 'antd'
import '../../css/case.scss'
import ApolloClientService from '../../services/apolloclient.service'
import moment from 'moment'
import SessionStorage from '../../util/sessionstore'
import { constants } from '../../constants'
import { PlusCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons'
import {
  fetchHealthCoachList,
  getActionCase,
  updateActionCase,
  deleteWorkLog,
  deleteComment,
  editWorkLog,
  editComment,
  updateLastViewed,
} from '../../store/action/actioncases.action'
import { connect } from 'react-redux'
import util from '../../util/util'
import WorkLog from './worklog'
import _ from 'lodash'
import { pointer } from 'd3'
import {
  loginAsCustomer,
  loginAsCompany,
} from '../../store/action/profile.action'

const { TabPane } = Tabs
const { Content } = Layout
const { TextArea } = Input
const { Option } = Select
const { Text } = Typography

const session = new SessionStorage()
const apolloClient = new ApolloClientService()

const _status = [
  {
    value: constants.ACTION_CASE_STATUS.ASSIGNED,
    label: 'Assigned',
  },
  {
    value: constants.ACTION_CASE_STATUS.RESOLVED,
    label: 'Resolved',
  },
  {
    value: constants.ACTION_CASE_STATUS.UNRESOLVED,
    label: 'Unresolved',
  },
  {
    value: constants.ACTION_CASE_STATUS.NOTANISSUE,
    label: 'Not an Issue',
  },
]

const _priority = [
  {
    value: constants.ACTION_CASE_PRIORITY.ONE,
    label: 'P1',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.TWO,
    label: 'P2',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.THREE,
    label: 'P3',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.FOUR,
    label: 'P4',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.CRITICAL,
    label: 'Critical',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.BLOCKER,
    label: 'Blocker',
  },
]

function ViewCase(props) {
  var history = useHistory()
  const isadmin =
    props.current_user?.role == constants.ROLE.ADMIN ||
    props.current_user?.role == constants.ROLE.SURGEON ||
    false
  const [workLog, setWorkLog] = useState(null)
  const [healthCoachList, setHealthCoachList] = useState([])
  const [actionCase, setActionCase] = useState(props.editCase)
  const [isLoading, setIsLoading] = useState({
    comment: false,
    healthCoachList: false,
  })
  const [isError, setIsError] = useState({
    showError: false,
    errorMessage: '',
  })
  const [caseModal, setCaseModal] = useState(false)
  const [sumError, setSumError] = useState(false)
  const [descError, setDescError] = useState(false)
  var location = useLocation()

  const profile = session.getProfile()
  const sumRef = useRef()
  const descRef = useRef()

  const savetimeTracking = (timeTrackingData) => {
    console.log(timeTrackingData, 'timeTrackingData')
    const combineInputs = { ...caseInputs, ...timeTrackingData }
    setCaseInputs(combineInputs)
    handleSaveClick(combineInputs)
  }

  const showCaseModal = () => {
    setCaseModal((prev) => !prev)
  }

  const currentUserId = profile?.user?._id || ''
  const currentUsername = profile?.user?.firstname || ''
  const currentUserCompanyId = profile.company?._id || ''

  const params = useParams()
  const caseId = params.caseid

  console.log(
    'props.healthCoachList ---------------->>>',
    props.healthCoachList
  )

  console.log('props.editCase ---------------->>>', props.editCase.patientId)

  useEffect(() => {
    if (isadmin) return
    const userList = props.healthCoachList?.map((user) => ({
      id: user._id,
      name: user.firstname + ' ' + user.lastname,
    }))
    console.log('userList ---------------->>>', userList)
    setHealthCoachList(userList)
  }, [props.healthCoachList])

  const [caseInputs, setCaseInputs] = useState({
    status: '',
    priority: '',
    assignedTo: '',
    summary: '',
    description: '',
    date: null,
    hrs: null,
    workDescription: null,
    min: null,
  })

  const [allowEdit, setAllowEdit] = useState({
    summary: {
      show: false,
      edit: false,
    },
    description: {
      show: false,
      edit: false,
    },
    assignedTo: {
      show: true,
      edit: false,
    },
  })

  const [comment, setComment] = useState('')
  const [editComment, setEditComment] = useState(null)

  useEffect(() => {
    setActionCase(props.editCase)
  }, [props.editCase])

  useEffect(() => {
    if (profile?.user?.role == constants.ROLE.COMPANY_ADMIN) {
      setAllowEdit((prev) => ({
        ...prev,
        summary: {
          show: true,
          edit: false,
        },
        description: {
          show: true,
          edit: false,
        },
        assignedTo: {
          show: true,
          edit: true,
        },
      }))
    }
    props.getActionCase(caseId)
    {
      !isadmin && props.getHealthCoachList({ companyid: currentUserCompanyId })
    }
    props.updateLastViewed({ caseId: caseId })
  }, [])

  useEffect(() => {
    if (actionCase.status) {
      setCaseInputs((prev) => ({
        ...prev,
        status: actionCase.status,
        priority: actionCase.priority,
        assignedTo: actionCase.assignedTo,
        summary: actionCase.summary,
        description: actionCase.caseDescription,
      }))
    }
  }, [actionCase])

  async function handleBackClick() {
    const isSurgeon = props.current_user?.role == constants.ROLE.SURGEON
    const admin = props.current_user?.role == constants.ROLE.ADMIN
    if (admin) history.push({ pathname: '/notification' })
    else if (isSurgeon) history.push({ pathname: '/inbox' })
    else history.push({ pathname: '/cases' })
  }

  function updateEditButton(name, value) {
    setAllowEdit((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        edit: value,
      },
    }))
  }

  async function handleAddCommentClick() {
    var comment1 = comment.trim()
    if (comment1.length == 0) return

    console.log('add comment clicked', comment)
    try {
      setIsLoading((prev) => ({ ...prev, comment: true }))
      const caseId = actionCase.caseId
      const commentObject = await apolloClient.addComment({
        caseId: caseId,
        comment: comment,
      })

      if (commentObject.status) {
        setComment('')
        await props.getActionCase(caseId)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading((prev) => ({ ...prev, comment: false }))
    }
  }

  function handleCancelClick() {
    setCaseInputs((prev) => ({
      ...prev,
      status: actionCase.status,
      priority: actionCase.priority,
      assignedTo: actionCase.assignedTo,
      summary: actionCase.summary,
      description: actionCase.caseDescription,
    }))

    updateEditButton('description', false)
    updateEditButton('summary', false)
  }

  const deleteWorkLog = async (input) => {
    var res = await props.deleteWorkLog(input)
    props.getActionCase(caseId)
  }

  const deleteComment = async (input) => {
    props.deleteComment(input)
    props.getActionCase(caseId)
  }

  var showConfirmDeleteBox = (type, input) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this work log?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => (type ? deleteComment(input) : deleteWorkLog(input)),
    })
  }

  const editWorkLog = async (worklog) => {
    setWorkLog(worklog)
    showCaseModal()
  }

  const saveEditedComment = async () => {
    await props.editComment({
      _id: editComment._id,
      caseId: caseId,
      comment: comment,
    })
    setComment('')
    setEditComment(null)
    await props.getActionCase(caseId)
  }

  const saveEditedWorkLog = async (worklog) => {
    await props.editWorkLog(worklog)
    await props.getActionCase(caseId)
  }

  async function handleSaveClick(worklogInputs) {
    console.log('save clicked', caseInputs)
    try {
      if (
        caseInputs.summary.trim() == '' ||
        caseInputs.description.trim() == ''
      ) {
        if (caseInputs.description.trim() == '') {
          setDescError(true)
          descRef.current.focus()
          message.error('enter desciption')
        }
        if (caseInputs.summary.trim() == '') {
          setSumError(true)
          sumRef.current.input.focus()
          message.error('enter summary')
        }
        return
      }
      const updateObject = {
        caseId: actionCase.caseId,
        priority: caseInputs.priority,
        healthCoachId: caseInputs.assignedTo,
        status: caseInputs.status,
        summary: caseInputs.summary,
        description: caseInputs.description,
        hrs: worklogInputs.hrs,
        mins: worklogInputs.mins,
        workDescription: worklogInputs.workDescription,
        createdAt: worklogInputs.createdAt,
      }

      const response = await props.updateActionCase(updateObject)
      if (response.status == constants.MESSAGE.SUCCESS) {
        await props.getActionCase(caseId)

        message.success('Case Updated')
        updateEditButton('description', false)
        updateEditButton('summary', false)
      } else {
        message.success(response?.message ?? 'Failed to updated case')
      }
    } catch (error) {
      console.log(error)
      message.success('Failed to updated case')
    }
  }

  function convertMinutesToHours(minutes) {
    if (minutes == 0) return ''

    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60

    let result = `${hours} hour${hours > 1 ? 's' : ''}`

    if (remainingMinutes > 0) {
      result += ` ${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`
    }

    return result
  }

  return (
    <div>
      <Spin spinning={props.isLoading}>
        <Layout className='layout'>
          <Breadcrumb style={{ margin: '1vh 4vh' }}>
            {/* {location.state?.home && (
              <Breadcrumb.Item>
                <Link to="/home">Home</Link>
              </Breadcrumb.Item>
            )} */}
            <Breadcrumb.Item>
              <Link to={isadmin ? '/notification' : '/cases'}>Cases</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Edit</Breadcrumb.Item>
          </Breadcrumb>
          <h1
            style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: '1vh',
            }}
          >
            {isadmin ? 'Message Detail' : 'CASE DETAILS'}
          </h1>
          <Content className='content'>
            <div className='card'>
              <div className='general-detail-container'>
                <h2>General Details</h2>
                <Button className='back-button' onClick={handleBackClick}>
                  Back
                </Button>
              </div>
              {!isadmin && (
                <div className='general-details'>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '30vw',
                      gap: '1vh',
                    }}
                  >
                    <div className='field'>
                      <Text className='detail-text'>Case# : </Text>
                      <Text>{actionCase.caseNumber}</Text>
                    </div>
                    <div className='field'>
                      <Text className='detail-text'>Type : </Text>
                      <Text>{actionCase.caseTitle}</Text>
                    </div>
                    <div className='field'>
                      <Text className='detail-text'>Status :</Text>
                      <Select
                        value={caseInputs.status}
                        style={{ width: 160 }}
                        onChange={(value) => {
                          if (value == 'Unassigned') {
                            setCaseInputs({
                              ...caseInputs,
                              status: value,
                              assignedTo: '',
                            })
                          } else {
                            setCaseInputs({ ...caseInputs, status: value })
                          }
                        }}
                      >
                        {_status.map((item) => {
                          return (
                            <Option value={item.value}> {item.label}</Option>
                          )
                        })}
                      </Select>
                    </div>
                    <div className='field'>
                      <Text className='detail-text'>Priority :</Text>
                      <Select
                        value={caseInputs.priority}
                        style={{ width: 160 }}
                        onChange={(value) =>
                          setCaseInputs({ ...caseInputs, priority: value })
                        }
                      >
                        {_priority.map((item) => {
                          return (
                            <Option value={item.value}> {item.label}</Option>
                          )
                        })}
                      </Select>
                    </div>
                    <div className='field'>
                      <Text className='detail-text'>Assigned to :</Text>
                      <Select
                        value={caseInputs.assignedTo}
                        style={{ width: 230 }}
                        loading={isLoading.healthCoachList}
                        disabled={
                          isLoading.healthCoachList ||
                          !allowEdit.assignedTo.edit
                        }
                        onChange={(value) =>
                          setCaseInputs({ ...caseInputs, assignedTo: value })
                        }
                      >
                        {healthCoachList
                          ?.sort((a, b) => a.name.localeCompare(b.name))
                          .map((item) => {
                            return <Option value={item.id}> {item.name}</Option>
                          })}
                      </Select>
                    </div>
                    <Row className='field  '>
                      <Text className='detail-text'>Total Work logged: </Text>
                      <Text>
                        {convertMinutesToHours(actionCase?.totalTimeSpent || 0)}
                      </Text>
                      <PlusCircleFilled
                        onClick={showCaseModal}
                        className='pluscirclefilled'
                      />
                    </Row>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '60vw',
                      gap: '1vh',
                    }}
                  >
                    <div className='field'>
                      <Text
                        style={{
                          fontWeight: 'bold',
                          width: '12vw',
                          textAlign: 'right',
                        }}
                      >
                        Summary :
                      </Text>
                      <Input
                        style={{ border: sumError ? '1px solid red' : null }}
                        ref={sumRef}
                        placeholder='Enter summary'
                        value={caseInputs.summary}
                        disabled={!allowEdit.summary.edit}
                        onChange={(e) => {
                          setCaseInputs({
                            ...caseInputs,
                            summary: e.target.value,
                          })
                          setSumError(false)
                        }}
                      />
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '2px',
                          alignItems: 'center',
                          textDecoration: 'underline',
                          color: 'blue',
                        }}
                      >
                        {allowEdit.summary.show && (
                          <Text
                            style={{ color: 'blue', width: 40 }}
                            onClick={() => updateEditButton('summary', true)}
                          >
                            Edit
                          </Text>
                        )}
                      </div>
                    </div>
                    <div className='field'>
                      <Text
                        style={{
                          fontWeight: 'bold',
                          width: '12vw',
                          textAlign: 'right',
                        }}
                      >
                        Description :
                      </Text>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                        }}
                      >
                        <TextArea
                          style={{
                            minHeight: '10vh',
                            border: descError ? '1px solid red' : null,
                          }}
                          ref={descRef}
                          value={caseInputs.description}
                          disabled={!allowEdit.description.edit}
                          placeholder='Enter description'
                          onChange={(e) => {
                            setCaseInputs({
                              ...caseInputs,
                              description: e.target.value,
                            })
                            setDescError(false)
                          }}
                        />
                        <div className='buttons' style={{ marginLeft: 'auto' }}>
                          <Button
                            type='default'
                            style={{ width: '8vw' }}
                            disabled={isLoading.save}
                            onClick={handleCancelClick}
                          >
                            Cancel
                          </Button>
                          <Button
                            style={{
                              width: '8vw',
                              backgroundColor: '#001529',
                              color: 'white',
                            }}
                            disabled={isLoading.save}
                            onClick={handleSaveClick}
                          >
                            Save
                          </Button>
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '2px',
                          alignItems: 'center',
                          textDecoration: 'underline',
                          color: 'blue',
                        }}
                      >
                        {' '}
                        {allowEdit.description.show && (
                          <Text
                            style={{ color: 'blue', width: 40 }}
                            onClick={() =>
                              updateEditButton('description', true)
                            }
                          >
                            Edit{' '}
                          </Text>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isadmin && (
                <div className='general-details-admin'>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '60vw',
                      gap: '1vh',
                    }}
                  >
                    <div className='field' style={{ marginBottom: '10px' }}>
                      <Text
                        className='detail-text'
                        style={{ paddingRight: 30 }}
                      >
                        Case# :
                      </Text>
                      <Text>{actionCase.caseNumber}</Text>
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '60vw',
                      gap: '1vh',
                    }}
                  >
                    <div className='field'>
                      <Text className='detail-text'>Summary :</Text>
                      <Input
                        style={{
                          border: sumError ? '1px solid red' : null,
                          marginLeft: 30,
                        }}
                        ref={sumRef}
                        placeholder='Enter summary'
                        value={caseInputs.summary}
                        disabled={!allowEdit.summary.edit}
                        onChange={(e) => {
                          setCaseInputs({
                            ...caseInputs,
                            summary: e.target.value,
                          })
                          setSumError(false)
                        }}
                      />
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '2px',
                          alignItems: 'center',
                          textDecoration: 'underline',
                          color: 'blue',
                        }}
                      >
                        {allowEdit.summary.show && (
                          <Text
                            style={{ color: 'blue' }}
                            onClick={() => updateEditButton('summary', true)}
                          >
                            Edit
                          </Text>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className='card '>
              <Row className='additional-detail-container'>
                <h2>Additional Details</h2>
              </Row>

              {caseModal && (
                <Modal
                  visible={caseModal}
                  footer={null}
                  onCancel={() => {
                    setWorkLog(null)
                    showCaseModal()
                  }}
                >
                  <Row>
                    <WorkLog
                      savetimeTracking={savetimeTracking}
                      editWorkLog={saveEditedWorkLog}
                      workLog={workLog}
                      actionCase={actionCase}
                      showCaseModal={() => {
                        setWorkLog(null)
                        showCaseModal()
                      }}
                    />
                  </Row>
                </Modal>
              )}

              <div
                className='additional-details'
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div className='field'>
                  <Text
                    style={{
                      fontWeight: 'bold',
                      width: '9vw',
                      textAlign: 'right',
                    }}
                  >
                    Clinic:{' '}
                  </Text>
                  <Text>{actionCase.customerName}</Text>
                </div>
                {actionCase.patientLastDigitOfPhone != '' && (
                  <div className='field'>
                    <Text
                      style={{
                        fontWeight: 'bold',
                        width: '9vw',
                        textAlign: 'right',
                      }}
                    >
                      Patient:{' '}
                    </Text>
                    <Text>
                      <Link
                        onClick={() =>
                          props.loginAsCustomer({
                            _id: props.editCase?.customerId,
                            name: props.editCase.customerName,
                            company: props.company?._id,
                          })
                        }
                        to={`/patient/${props.editCase.patientId}`}
                      >
                        {'XXXXX-X' + actionCase.patientLastDigitOfPhone}
                      </Link>
                    </Text>
                  </div>
                )}
                <div className='field'>
                  <Text
                    style={{
                      fontWeight: 'bold',
                      width: '9vw',
                      textAlign: 'right',
                    }}
                  >
                    Reported On:{' '}
                  </Text>
                  <Text>
                    {' '}
                    {moment(actionCase.createdDate).format(
                      'MM/DD/YYYY, h:mm a'
                    )}
                  </Text>
                </div>
              </div>
            </div>
            {/* TABS */}
            <Tabs defaultActiveKey='1' tabBarStyle={{ marginLeft: '20px' }}>
              <TabPane tab='Comments' key='1'>
                <div className='card'>
                  {/* <h2>Comments</h2> */}
                  <div className='comments' style={{ padding: '2vh 4vh' }}>
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1vh',
                      }}
                    >
                      <Text strong style={{ width: '20vw' }}>
                        {currentUsername}
                      </Text>
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '5%',
                        }}
                      >
                        <TextArea
                          rows={2}
                          style={{ width: '80%', minHeight: '12vh' }}
                          placeholder='Enter comment'
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        />
                        <Button
                          style={{
                            width: '10vw',
                            marginTop: 'auto',
                            backgroundColor: '#001529',
                            color: 'white',
                          }}
                          disabled={isLoading.comment}
                          loading={isLoading.comment}
                          onClick={() => {
                            editComment
                              ? saveEditedComment()
                              : handleAddCommentClick()
                          }}
                        >
                          {editComment ? 'Edit' : 'Add'}
                        </Button>
                      </div>
                    </div>
                    <Divider />
                    <div className='comment-list'>
                      {actionCase?.comments?.map((item) => (
                        <div
                          key={item.commented_date}
                          className='comment'
                          style={{
                            width: '60%',
                            marginLeft:
                              item.userid == currentUserId ? 'auto' : '0',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent:
                                item.userid == currentUserId ? 'end' : 'start',
                              alignContent: 'end',
                              margin: '0px  0%',
                              gap: '0.5rem',
                              width: 'content',
                            }}
                          >
                            <Text
                              strong
                              style={{
                                minWidth: '10vh',
                                fontSize: '1rem',
                              }}
                            >
                              {item.userName}
                            </Text>
                            <Text
                              style={{
                                alignSelf: 'center',
                                fontSize: '0.8rem',
                              }}
                            >
                              on{' '}
                              {moment(item.commented_date)
                                .format('MM/DD/YYYY, h:mm a')
                                .toString()}
                            </Text>
                          </div>

                          <div
                            style={{
                              minHeight: '5vh',
                              backgroundColor: 'white',
                              border: '1px solid #ccc',
                              padding: '10px',
                              boxShadow: 'gray 1px 1px 3px',
                              borderRadius: '5px',
                            }}
                          >
                            {props.current_user._id == item.userid && (
                              <>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '20px',
                                    alignItems: 'center',
                                    marginRight: '3px',
                                    marginLeft: '3px',
                                    textDecoration: 'underline',
                                    color: 'blue',
                                    cursor: 'pointer',
                                    flexWrap: 'nowrap',
                                  }}
                                >
                                  <Text
                                    style={{
                                      color: 'blue',
                                      paddingLeft: '20px',
                                    }}
                                    onClick={() => {
                                      setComment(item.comment)
                                      setEditComment(item)
                                    }}
                                  >
                                    Edit
                                  </Text>

                                  <Text
                                    style={{
                                      color: 'blue',
                                      paddingLeft: '10px',
                                    }}
                                    onClick={() =>
                                      showConfirmDeleteBox(true, {
                                        wlid: item._id,
                                        caseId: props.editCase.caseId,
                                      })
                                    }
                                  >
                                    Delete
                                  </Text>
                                </div>
                              </>
                            )}
                            {item.comment}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </TabPane>
              {!isadmin && (
                <TabPane tab='Work log ' key='2'>
                  <Row className='card'>
                    <Row className='worklog-list'>
                      {actionCase?.workLog
                        ?.sort(
                          (a, b) =>
                            new Date(b.createdAt) - new Date(a.createdAt)
                        )
                        ?.map((item) => (
                          <Row key={item.createdAt} className='worklog'>
                            <Row className='worklog-row'>
                              <Text
                                strong
                                style={{
                                  minWidth: '10vh',
                                  fontSize: '1rem',
                                }}
                              >
                                {item.userName}
                              </Text>
                              <Text
                                style={{
                                  fontSize: '0.8rem',
                                  paddingTop: '3px',
                                }}
                              >
                                on{' '}
                                {moment(item.createdAt).format(
                                  'MM/DD/YYYY, h:mm a'
                                )}
                              </Text>
                            </Row>

                            <Row className='workdescription-container'>
                              <Row className='timeMin-span'>
                                <Text strong className='total-time-label'>
                                  Total Time:
                                </Text>
                                <Text className='total-time-value'>
                                  {item.timeMin
                                    ? convertMinutesToHours(item.timeMin)
                                    : 0}
                                </Text>
                                {props.current_user._id == item.userId && (
                                  <>
                                    {' '}
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '20px',
                                        alignItems: 'center',
                                        marginRight: '3px',
                                        marginLeft: '3px',
                                        textDecoration: 'underline',
                                        color: 'blue',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <Text
                                        style={{
                                          color: 'blue',
                                          paddingLeft: '20px',
                                        }}
                                        onClick={() =>
                                          editWorkLog({
                                            ...item,
                                            wlid: item._id,
                                            caseId: props.editCase.caseId,
                                          })
                                        }
                                      >
                                        Edit
                                      </Text>
                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '20px',
                                        marginRight: '3px',
                                        marginLeft: '3px',
                                        alignItems: 'center',
                                        textDecoration: 'underline',
                                        color: 'blue',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <Text
                                        style={{
                                          color: 'blue',
                                          paddingLeft: '10px',
                                        }}
                                        onClick={() =>
                                          showConfirmDeleteBox(false, {
                                            wlid: item._id,
                                            caseId: props.editCase.caseId,
                                          })
                                        }
                                      >
                                        Delete
                                      </Text>
                                    </div>
                                  </>
                                )}
                              </Row>
                              <Row className='timeMin-span'>
                                <Text strong className='total-time-label'>
                                  Work Details:{' '}
                                </Text>
                                <Text className='total-time-value'>
                                  {item.workDescription}
                                </Text>
                              </Row>
                            </Row>
                          </Row>
                        ))}
                    </Row>
                  </Row>
                </TabPane>
              )}
            </Tabs>
          </Content>
        </Layout>
      </Spin>
    </div>
  )
}

const mapStateToProps = (state) => {
  console.log('state ---------------->>>', state)

  return {
    editCase: state.actioncase.editcase,
    isLoading: state.actioncase.isLoading,
    healthCoachList: state.actioncase.healthCoachList,
    token: util.verifyToken(state.profile.token),
    company: state.profile.company,
    current_user: state.profile.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getActionCase: (params) => {
      return dispatch(getActionCase(params))
    },
    updateActionCase: (params) => {
      return dispatch(updateActionCase(params))
    },

    getHealthCoachList: (params) => {
      return dispatch(fetchHealthCoachList(params))
    },

    deleteWorkLog: (params) => dispatch(deleteWorkLog(params)),
    deleteComment: (params) => dispatch(deleteComment(params)),
    editWorkLog: (params) => dispatch(editWorkLog(params)),
    editComment: (params) => dispatch(editComment(params)),
    loginAsCustomer: (params) => dispatch(loginAsCustomer(params)),
    updateLastViewed: (caseId) => dispatch(updateLastViewed(caseId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewCase)

//export default ViewCase;
